import { ChangeDetectorRef, Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { CommonFunctions } from 'src/app/shared/common-functions';
import { CouponsService } from 'src/app/shared/services/coupons.service';
import { ViewCartService } from 'src/app/shared/services/view-cart.service';
import { SwiperOptions } from 'swiper';
import { CoponAddedDialogComponent } from '../copon-added-dialog/copon-added-dialog.component';
import { EncryptDecryptService } from 'src/app/core/services/encrypt-decrypt.service';
import { StorageService } from 'src/app/shared/services/storage.service';
declare var dataLayer;
@Component({
  selector: 'app-rewards-and-offers-dialog',
  templateUrl: './rewards-and-offers-dialog.component.html',
  styleUrls: ['./rewards-and-offers-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RewardsAndOffersDialogComponent implements OnInit {
  public beveragesCount: number = 10;
  public applyCouponVal = '';
  public rewardText: string = 'Details';
  public clikedIndex: number;
  public wordLimit: number;
  public showRadioBtn: boolean = false;
  public isCoponApplied: boolean = false;
  public btnVal = 'Use Offer';
  public allOffers: any = [];
  public allOfferCouponCodes: any = [];
  public applicableOffersArray: any = [];
  public nonApplicableOffersArray: any = [];
  public showEligibleProducts: boolean = false;
  public itemIndex: number;
  public isPhone: boolean;
  public noAOffers: boolean;
  public noNAOffers: boolean;
  public showCpnCode: boolean = false;
  public showAppliedCpn: boolean = false;
  public appliedCpnArray: any = [];
  public nonAppDetailArr: any = [];
  public cpnsArr: any = [];
  public appliedOffersNo: number;
  public discountPrice;
  public discountedTotal;
  public showRemoveBtn: boolean = false;
  public totalOrderAmt: any;
  public applicableOffersArrayNew: any;
  public discountAmount: any;
  public totalCartAmt;
  public isClicked: boolean = false;
  public removeItemIndex: number;
  public couponForm: FormGroup;
  public userType: string;
  public userId: any;
  public tierType: any;
  public selectedCouponType;
  public couponStatus
  public coponInfoArray = [];
  public applyManually: boolean;
  public offerAmount: string;
  constructor(private ref: ChangeDetectorRef,
    private commonFunction: CommonFunctions,
    private couponService: CouponsService,
    private fb: FormBuilder,
    private storageService: StorageService,
    private cd: ChangeDetectorRef,
    private encryptDecryptService: EncryptDecryptService,
    private bottomSheetRef: MatBottomSheetRef<RewardsAndOffersDialogComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    public dialog: MatDialog,
    private viewCart: ViewCartService) {
    this.initateForm();
    this.isPhone = this.commonFunction.identifyDeviceType();
    this.userType = this.commonFunction.getUserType();
    this.userId = this.commonFunction.getUserId();
    this.tierType = this.commonFunction.getTierType();
  }
  ngOnInit(): void {
    this.applicableOffersArrayNew = this.data['applicableOffersArrayNew'];
    this.nonApplicableOffersArray = this.data['nonApplicableOffersArray'];
    this.appliedCpnArray = this.data['couponsArray'];
    this.noAOffers = (this.applicableOffersArrayNew != undefined && this.applicableOffersArrayNew.length > 0) ? false : true;
    this.noNAOffers = (this.nonApplicableOffersArray != undefined && this.nonApplicableOffersArray.length > 0) ? false : true;
    this.showAppliedCpn = this.appliedCpnArray.length > 0 ? true : false;
    this.rewardText == 'Details' ? this.wordLimit = 70 : this.wordLimit = 150;
    this.nonAppDetailArr = this.nonApplicableOffersArray.map(v => ({ ...v, showDetails: false }));
    this.cpnsArr = this.data['couponsArray'];
    this.appliedOffersNo = this.cpnsArr.length;
    let snackbarData = JSON.parse(localStorage.getItem('snackbarData'));
    let priceDetails = snackbarData['response'];
    this.totalOrderAmt = priceDetails.total.value;
    this.discountAmount = priceDetails.discountAmount.value;
    this.totalCartAmt = this.totalOrderAmt + this.discountAmount;
    this.appliedCpnArray = this.appliedCpnArray.map(v => ({ ...v, showDetails: false }));
  }
  public initateForm() {
    this.couponForm = this.fb.group({
      couponName: ["", Validators.pattern("^[A-Za-z0-9]{1,50}$")],
    })
    this.manualCouponInput();
  }
  config: SwiperOptions = {
    observer: true,
    observeParents: true,
    pagination: { el: '.swiper-pagination', clickable: true },
    autoHeight: true,
    allowTouchMove: true,
    breakpoints: {
      320: {
        slidesPerView: 1.1,
        spaceBetween: 15
      },
      480: {
        spaceBetween: 25,
        slidesPerView: 1.2
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 25,
      }
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    loop: false,
  };
  onSwiper([swiper]) {
  }
  onSlideChange() {
  }
  setControlledSwiper(event) { }
  config1: SwiperOptions = {
    observer: true,
    observeParents: true,
    pagination: { el: '.swiper-pagination', clickable: true },
    autoHeight: true,
    allowTouchMove: true,
    breakpoints: {
      320: {
        slidesPerView: 1.1,
        spaceBetween: 10
      },
      480: {
        spaceBetween: 20,
        slidesPerView: 1.2
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 25,
      }
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    loop: false,
  };
  onSwiper1([swiper]) {
  }
  onSlideChange1() {
  }
  setControlledSwiper1(event) { }
  public detailCoupon(data) {
    data['showDetails'] = !data['showDetails'];
  }
  public useReward(data, index) {
    this.selectedCouponType = data;
    if (data.conditionLevel === 'item') {
      this.showEligibleProducts = true;
      this.itemIndex = index;
      this.ref.detectChanges();
    } else {
      this.showEligibleProducts = false;
      this.itemIndex = index;
      this.applyInvoiceCoupon(data);
    }
  }
  public closeSheet() {
    this.bottomSheetRef.dismiss(true);
  }
  applyCouponRes;
  public applyInvoiceCoupon(data) {
    let requestPayload = {
      "basketId": this.storageService.getBasketId(),
      "couponCode": this.encryptDecryptService.encryptData(data.couponNo),
    }
    this.isClicked = true;
    this.couponService.applyCoupon(requestPayload).subscribe((result) => {
      this.couponApplied(data, result)
      this.applyCouponRes = result['response']
      let obj = result['response']['message'];
      this.couponStatus = result['response']
      if (obj === 'OK || Coupon Applied Successfully') {
        this.addToAppliedArr(data['couponNo'], null);
      }
      this.isClicked = false;
      this.coponAddedSuccess(data, obj);
    }, (error) => {
      this.isClicked = false;
      this.commonFunction.displaySnackBarMessage(error.error.response[0], 'failure')
    })
  }
  public coponAddedSuccess(data, obj) {
    let newData = {
      'dataObj': obj,
      'selectedCouponType': this.selectedCouponType
    }
    const dialogRef = this.dialog.open(CoponAddedDialogComponent, {
      data: newData,
      width: '400px',
      panelClass: "dialog-no-padding"
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result['dataObj'] === 'Coupon Deleted successfully') {
        data['isApplied'] = false;
        this.showEligibleProducts = false;
        this.ref.detectChanges();
        this.getChorotItem();
      }
    })
  }
  public couponApplied(data, obj) {
    if (data.uniqueIndex) {
      this.applicableOffersArrayNew.forEach(res => {
        if (res['uniqueIndex'] == data.uniqueIndex) {
          data['isApplied'] = true;
          res['isApplied'] = true;
          this.appliedCpnArray.push(res);
        }
      })
    } else {
      data['isApplied'] = true;
      this.applicableOffersArrayNew.forEach(res => {
        if (res['couponNo'] == data['couponNo']) {
          res['isApplied'] = true;
          this.appliedCpnArray.push(res);
        }
      })
    }
    this.showAppliedCpn = this.appliedCpnArray.length > 0 ? true : false;
    this.getChorotItem();
    this.ref.detectChanges();
  }
  public selectedOffer(data, product) {
    data.items && data.items.forEach(item => {
      if (item.lineItemId == product.lineItemId) {
        item['selectedLineItem'] = true;
      } else {
        item['selectedLineItem'] = false;
      }
    })
    let requestPayload
    if (data.uniqueIndex) {
      requestPayload = {
        "basketId": this.storageService.getBasketId(),
        "couponCode": this.encryptDecryptService.encryptData(data.couponNo),
        "lineItemId": product.lineItemId,
        "skuId": product.itemId,
        "uniqueIndex": data.uniqueIndex,
        "promoSkuId": product.promoSkuId,
        "promoLineItemId": product.promoLineItemId
      }
    }
    if (!data.uniqueIndex) {
      requestPayload = {
        "basketId": this.storageService.getBasketId(),
        "couponCode": this.encryptDecryptService.encryptData(data.couponNo),
        "lineItemId": product.lineItemId,
        "skuId": product.itemId,
        "promoSkuId": product.promoSkuId,
        "promoLineItemId": product.promoLineItemId
      }
    }
    this.isClicked = true;
    this.couponService.applyCoupon(requestPayload).subscribe((result) => {
      this.couponApplied(data, result);
      this.showEligibleProducts = false;
      this.couponStatus = result['response'];
      let obj = result['response']['message'];
      this.isClicked = false;
      this.coponAddedSuccess(data, obj)
    }, (error) => {
      this.isClicked = false;
      this.commonFunction.displaySnackBarMessage(error.error.response[0], 'failure')
    })
  }
  public removeCoupon(data, index) {
    this.selectedCouponType = data;
    this.removeItemIndex = index;
    let lineItemId;
    data.items.forEach(itm => {
      if (itm.selectedLineItem) {
        lineItemId = itm.lineItemId;
      }
    })
    this.isClicked = true;
    let req;
    if (data.conditionLevel === 'invoice') {
      req = {
        "basketId": this.storageService.getBasketId(),
        'couponCode': this.encryptDecryptService.encryptData(data['couponCode'] ? data['couponCode'] : data['couponNo']),
        'lineItemId': '',
        'uniqueIndex': ''
      }
    }
    if (data.conditionLevel === 'item') {
      if (!lineItemId) {
        if (data.promoCategory === 'bxgy') {
          lineItemId = data.items[0]['lineItemId'];
        }
      }
      req = {
        "basketId": this.storageService.getBasketId(),
        'couponCode': this.encryptDecryptService.encryptData(data['couponCode'] ? data['couponCode'] : data['couponNo']),
        'lineItemId': lineItemId,
        'uniqueIndex': data['uniqueIndex'] ? data['uniqueIndex'] : null
      }
    }
    this.couponService.deleteCoupon(req).subscribe(res => {
      if (res['response'] === 'Coupon Deleted successfully') {
        let obj = res['response'];
        this.removeFromAppliedArr(data);
        this.isClicked = false;
        this.coponAddedSuccess(data, obj);
      }
    }, (error) => {
      this.isClicked = false;
      this.commonFunction.displaySnackBarMessage(error.error.response[0], 'failure')
    })
  }
  public applyCoupon2() {
    let couponCode = this.couponForm.get('couponName').value;
    if (couponCode && this.couponForm.valid) {
      let requestPayload = {
        "basketId": this.storageService.getBasketId(),
        "couponCode": this.encryptDecryptService.encryptData(couponCode)
      }
      this.commonFunction.showLoader();
      this.couponService.applyCoupon(requestPayload).subscribe((result) => {
        if (result['response']['message'] === 'Coupon applied successfully.' || result.status == 200) {
          this.showRemoveBtn = true;
          this.couponmessg = 'Coupon applied successfully!'
          this.couponForm.get('couponName').disable();
          localStorage.setItem('manualCouponCode', couponCode);
          this.getApplicableOffers();
        }
        let obj = result['response'];
        this.couponStatus = result['response']
        this.commonFunction.hideLoader()
      }, (error) => {
        this.commonFunction.hideLoader()
        this.commonFunction.displaySnackBarMessage(error.error.response, 'failure')
      })
    }
  }
  removeCouponCode() {
    let couponCode = localStorage.getItem('manualCouponCode');
    let req
    if (couponCode) {
      req = {
        "basketId": this.storageService.getBasketId(),
        'couponCode': this.encryptDecryptService.encryptData(couponCode),
        'lineItemId': '',
        'uniqueIndex': ''
      }
    }
    this.commonFunction.showLoader();
    this.couponService.deleteCoupon(req).subscribe(res => {
      if (res['response'] === 'Coupon Deleted successfully' || res.status == 200) {
        this.couponmessg = ''
        this.showRemoveBtn = false;
        localStorage.removeItem('manualCouponCode');
        this.couponForm.get('couponName').enable();
        this.couponForm.get('couponName').reset();
        this.couponmessg = 'Coupon Deleted successfully!';
        this.getApplicableOffers();
        this.commonFunction.hideLoader();
      }
    }, (error) => {
      this.commonFunction.displaySnackBarMessage(error.error.response[0], 'failure')
    })
  }
  couponmessg = ''
  public manualCouponInput() {
    let manualCouponCode = localStorage.getItem('manualCouponCode');
    if (manualCouponCode) {
      this.couponForm.get('couponName').patchValue(manualCouponCode)
      this.couponForm.get('couponName').disable();
      this.couponmessg = 'Coupon applied successfully!';
      this.showRemoveBtn = true;
      this.showCpnCode = true;
    } else {
      this.couponForm.get('couponName').enable();
      this.couponForm.get('couponName').reset();
      this.couponmessg = '';
      this.showRemoveBtn = false;
      this.showCpnCode = false;
    }
  }
  public toggleContent() {
    this.showCpnCode = !this.showCpnCode;
  }
  public addToAppliedArr(cpn, uindx) {
    if (uindx) {
      this.applicableOffersArrayNew.forEach(res => {
        if ((res['uniqueIndex'] == uindx)) {
          res['isApplied'] = true;
          this.appliedCpnArray.push(res);
        }
      })
    } else {
      this.applicableOffersArrayNew.forEach(res => {
        if ((res['couponNo'] == cpn)) {
          res['isApplied'] = true;
          this.appliedCpnArray.push(res);
        }
      })
    }
    if (this.appliedCpnArray.length > 0) {
      this.showAppliedCpn = true;
      this.appliedOffersNo = this.appliedCpnArray.length;
    } else {
      this.showAppliedCpn = false;
      this.appliedOffersNo = 0;
    }
  }
  public removeFromAppliedArr(data) {
    let itemPos;
    if (data.uniqueIndex !== "" && data.uniqueIndex !== null) {
      for (let i = 0; i < this.appliedCpnArray.length; i++) {
        if (this.appliedCpnArray[i].uniqueIndex == data.uniqueIndex) {
          itemPos = i;
        }
      }
    } else {
      for (let i = 0; i < this.appliedCpnArray.length; i++) {
        if (this.appliedCpnArray[i].couponNo == data.couponNo) {
          itemPos = i;
        }
      }
    }
    if (itemPos > -1) {
      this.appliedCpnArray.splice(itemPos, 1);
    }
    if (this.appliedCpnArray.length > 0) {
      this.appliedOffersNo = this.appliedCpnArray.length;
      this.showAppliedCpn = true;
    } else {
      this.showAppliedCpn = false;
      this.appliedOffersNo = 0;
    }
  }
  public getBasket(): void {
    let basketId = this.storageService.getBasketId();
    let data = {
      'basketId': basketId
    }
    this.viewCart.getbasketItem(data).subscribe((res) => {
      let cartData = res['response'];
      let data = {
        'couponsArray': cartData['coupons']
      }
      localStorage.setItem('snackbarData', JSON.stringify(res));
    }, (error: any) => {
      if (error.error.status == 400 || error.error.status == 401 || error.error.status == 500) {
        this.commonFunction.displaySnackBarMessage(error.error.response[0], 'failure');
      }
    })
  }
  public getChorotItem() {
    this.allOfferCouponCodes = [];
    let cohortData = JSON.parse(localStorage.getItem('cohortData'))
    this.allOffers = cohortData.offers;
    if (this.allOffers) {
      this.allOffers.forEach(element => {
        this.allOfferCouponCodes.push(element.couponCode)
      });
      this.getApplicableOffers();
    }
  }
  public getApplicableOffers(): any {
    this.applicableOffersArrayNew = [];
    let basketId = this.storageService.getBasketId();
    let requestPayload = {
      "basketId": basketId,
      "coupons": this.allOfferCouponCodes
    }
    this.couponService.getApplicableCoupons(requestPayload).subscribe((result) => {
      this.totalCartAmt = result['response'].totalCartAmt;
      this.totalOrderAmt = Math.round(+result['response'].totalOrderAmt * 100) / 100;
      this.cd.markForCheck();
      this.applicableOffersArray = result['response']['applicableCoupons'];
      this.applicableOffersArray.forEach(element1 => {
        this.allOffers.forEach(element => {
          if (element.couponCode == element1.couponNo) {
            let obj = {
              'couponImageUrl': element.imageUrl,
              'conditionLevel': element1.conditionLevel,
              'couponNo': element1.couponNo,
              'discountLevel': element1.discountLevel,
              'expiryDate': element.endDate,
              'promoType': element1.promoType,
              "offerCategory": element.offerCategory,
              "content": element.content,
              'title': element.title,
              'isApplied': false,
              'items': element1.items,
              'promotionDescription': element1.promotionDescription,
              'promotionName': element1.promotionName,
              'showDetails': false,
              'uniqueIndex': null
            }
            this.applicableOffersArrayNew.push(obj)
          }
        })
      });
      this.nonApplicableOffersArray = this.allOffers.filter((item) =>
        !this.applicableOffersArrayNew.some(item1 => item.couponCode === item1.couponNo));
      this.applicableIndex();
    }, (error: any) => {
    })
  }
  nubmer = 1;
  uniqCoupnArray;
  public applicableIndex() {
    let lastCouponNo;
    let duplicateCouponNo = this.applicableOffersArrayNew
      .map(e => e['couponNo'])
      .map((e, i, final) => final.indexOf(e) !== i && i)
      .filter(obj => this.applicableOffersArrayNew[obj])
      .map(e => this.applicableOffersArrayNew[e]["couponNo"])
    this.uniqCoupnArray = [...new Set(duplicateCouponNo)];
    for (let i = 0; i < this.applicableOffersArrayNew.length; i++) {
      if (this.uniqCoupnArray.includes(this.applicableOffersArrayNew[i]['couponNo'])) {
        if (i > 0) {
          this.applicableOffersArrayNew[i - 1]['couponNo'] != this.applicableOffersArrayNew[i]['couponNo'] ? this.nubmer = 1 : '';
        }
        this.applicableOffersArrayNew[i]['uniqueIndex'] = this.applicableOffersArrayNew[i]['couponNo'] + '_' + this.nubmer;
        this.applicableOffersArrayNew[i]['duplicate'] = true;
        this.nubmer++
      } else {
        this.nubmer = 1;
      }
    }
    this.updatedListOfIndex();
  }
  public updatedListOfIndex() {
    if (this.appliedCpnArray && this.appliedCpnArray.length != 0) {
      this.appliedCpnArray.forEach(res => {
        this.applicableOffersArrayNew.forEach(item => {
          if (res.uniqueIndex) {
            if (item.uniqueIndex && item.uniqueIndex == res['uniqueIndex'] && res['uniqueIndex']) {
              this.applicableOffersArrayNew.splice(this.applicableOffersArrayNew.findIndex(function (i) {
                return i.uniqueIndex == item.uniqueIndex;
              }), 1);
            }
          } else {
            if (res.couponNo == item.couponNo) {
              this.applicableOffersArrayNew.filter(data => data.couponNo === item.couponNo);
              this.applicableOffersArrayNew.splice(this.applicableOffersArrayNew.findIndex(function (i) {
                return i.couponNo == item.couponNo;
              }), 1);
            }
          }
        })
      })
    }
    if (this.appliedCpnArray.length > 0) {
      this.showAppliedCpn = true;
    } else {
      this.showAppliedCpn = false;
    }
    this.unUsedApplicableOffers();
  }
  public unUsedApplicableOffers() {
    let nonApplicableLineItem;
    if (this.applicableOffersArrayNew.length != 0) {
      nonApplicableLineItem = this.applicableOffersArrayNew.filter(data => {
        if (data.offerCategory === 'bxgy') {
          return data['items'].every(x => x.isApplicablePromoItem == false)
        } else {
          return data['items'].every(x => x.isApplicableItem == false)
        }
      })
      this.applicableOffersArrayNew = this.applicableOffersArrayNew.filter(data => {
        if (data.offerCategory === 'bxgy') {
          return !data['items'].every(x => x.isApplicablePromoItem == false)
        } else {
          return !data['items'].every(x => x.isApplicableItem == false)
        }
      })
      this.nonApplicableOffersArray = [...this.nonApplicableOffersArray, ...nonApplicableLineItem];
    }
    this.applicableOffersArrayNew.length == 0 ? this.noAOffers = true : this.noAOffers = false;
  }
  useOfferClickGA(rewardTitle) {
    dataLayer.push({
      'event': 'apply_offer_user_offer_click',
      'userID': this.userId,
      'reward_title': rewardTitle.length != 0 ? rewardTitle : 'NA',
      'user_type': this.userType,
      'tier': this.tierType
    })
  }
  applyCouponCodeGA(cpnCode) {
    dataLayer.push({
      'event': 'apply_offer_apply_coupon_click',
      'userID': this.userId,
      'coupon_code_search': cpnCode.length != 0 ? cpnCode : 'NA',
      'user_type': this.userType,
      'tier': this.tierType
    })
  }
  offersDetailGA(data) {
    if (data) {
      dataLayer.push({
        'event': 'apply_offer_details_click',
        'userID': this.userId,
        'user_type': this.userType,
        'tier': this.tierType
      })
    }
  }
}
